import { Table as MuiTable } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";

interface Props {
  header: JSX.Element;
  body: JSX.Element;
  ref?: React.MutableRefObject<any>;
}

const Table: React.FC<Props> = ({ header, body, ref }) => {
  return (
    <MuiTable
      stickyHeader
      className="relative min-h-[100px]"
      ref={ref}
      sx={{
        borderCollapse: "separate",
        "& .MuiTableCell-stickyHeader": {
          backgroundColor: "#fff",
          position: "sticky",
          top: 0,
          zIndex: 20,
        },
        "& .MuiTableBody-root .MuiTableCell-root": {
          position: "relative",
          zIndex: 1,
        },
      }}
    >
      <TableHead>
        <TableRow>{header}</TableRow>
      </TableHead>
      <TableBody>{body}</TableBody>
    </MuiTable>
  );
};

export default Table;
